module.exports = __webpack_public_path__ + "img/loading.d38ad71c.svg";